const IBMKTTRACK_SCRIPT_ID = 'ibmkttrack';
const IBMKTTRACK_SCRIPT_SRC = '/scripts/common/js/ibmkttrack.js';

/**
 * Reads a cookie value by name from document.cookie.
 * Returns undefined when the cookie is absent.
 */
function getCookie(name: string): string | undefined {
  const match = document.cookie.split('; ').find((row) => row.startsWith(`${name}=`));
  return match?.slice(name.length + 1);
}

/**
 * Injects the IBKR marketing/fingerprint tracking script into the document head.
 * No-op when the script element already exists.
 *
 * Exported so the GDPR consent flow can enable tracking the moment a user
 * accepts performance cookies, without waiting for the "web" cookie to be
 * written by the server and re-read on a later page load.
 */
export function injectIbmktrackScript() {
  if (document.getElementById(IBMKTTRACK_SCRIPT_ID)) return;
  const element = document.createElement('script');
  element.type = 'text/javascript';
  element.id = IBMKTTRACK_SCRIPT_ID;
  element.src = IBMKTTRACK_SCRIPT_SRC;
  document.head.appendChild(element);
}

/**
 * Fingerprint tracking via ibmkttrack.js.
 *
 * Checks for the presence of the "web" cookie. When set, the IBKR marketing
 * tracking script is appended to the document head. This mirrors the legacy
 * webapp behaviour where fingerprint tracking is only enabled for web platform
 * users (identified by the "web" cookie).
 */
export function initFingerprintTracking() {
  if (getCookie('web')) {
    injectIbmktrackScript();
  }
}
